import { render } from "./TwoFAQRCode.vue?vue&type=template&id=1712df46"
import script from "./TwoFAQRCode.vue?vue&type=script&lang=js"
export * from "./TwoFAQRCode.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__